/**
 * @module store/points/mutations
 *
 * @version 1.0.0
 * @copyright SBC 2019
 */


import * as types from '@/store/mutation-types';

/* eslint-disable no-param-reassign */
export default {
  /**
   * Mutation: Задание списка точек на карте
   *
   * @since Version 1.0.0
   */
  [types.GET_STATS_ASYNC.PENDING](state) {
    state.isStatsLoading = true;
  },


  /**
   * Mutation: Задание списка точек на карте
   *
   * @since Version 1.0.0
   */
  [types.GET_STATS_ASYNC.FAILURE](state) {
    state.isStatsLoading = false;
  },


  /**
   * Mutation: Задание списка точек на карте
   *
   * @since Version 1.0.0
   */
  [types.GET_STATS_ASYNC.SUCCESS](state, stats) {
    state.stats = stats;
    state.isStatsLoading = false;
  },
};
/* eslint-enable no-param-reassign */
